import { authAxios } from "@/api/axios.ts";
import { Broadcast, BroadcastNoAuth } from "@/api/broadcast/broadcast.types.ts";

class BroadcastRequests {
  static isLoggedIn() {
    return Boolean(localStorage.getItem("splay:token"));
  }
  static async getBroadcastCategories(isKids?: boolean) {
    const searchParams = new URLSearchParams();
    if (isKids) searchParams.append("is_kids", String(isKids));

    return authAxios
      .get<
        { id: number; name: string }[]
      >(this.isLoggedIn() ? "/broadcast/categories" : "/content/no-auth/broadcasts-categories/", { params: searchParams })
      .then((res) => res.data);
  }
  static async getBroadcasts({ category, isKids }: { category?: string; isKids?: boolean }) {
    const searchParams = new URLSearchParams();
    if (category) searchParams.append("category", String(category));
    if (isKids) searchParams.append("is_kids", String(isKids));

    return authAxios.get<Broadcast[]>("/broadcast/broadcasts", { params: searchParams }).then((res) => res.data);
  }
  static async getBroadcastsNoAuth({ category, isKids }: { category?: string; isKids?: boolean }) {
    const searchParams = new URLSearchParams();
    if (category) searchParams.append("category", String(category));
    if (isKids) searchParams.append("is_kids", String(isKids));

    return authAxios
      .get<BroadcastNoAuth>("/content/no-auth/broadcasts/", { params: searchParams })
      .then((res) => res.data.results);
  }
  static async getBroadCardDetail(id: number) {
    return authAxios.get<Broadcast>(`/broadcast/broadcasts/${id}`).then((res) => res.data);
  }
}

export default BroadcastRequests;
